import React from 'react';
import PharmacyNetworksList from './components/PharmacyNetworksList/PharmacyNetworksList';

const PharmacyNetwork = () => {
  return <PharmacyNetworksList />;
};

export default PharmacyNetwork;
